/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateAlbumModelSchema } from "../createOrUpdateAlbumModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного альбома
 */
export const postApiAlbums200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiAlbums400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAlbums401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAlbums403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Авторы не найдены
 */
export const postApiAlbums404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAlbums500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса.
 */
export const postApiAlbumsMutationRequestSchema = z.lazy(() => createOrUpdateAlbumModelSchema).describe("Тело запроса.")

export const postApiAlbumsMutationResponseSchema = z.lazy(() => postApiAlbums200Schema)